// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2QSuh","col":"styles_col__6Lb37","fulfillmentStatus":"styles_fulfillmentStatus__1czXQ","emailCol":"styles_emailCol__11tFB"};